
import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  components: {
    Multiselect: () => import("vue-multiselect"),
    SearchAdvanced: () => import("../Homepage/SearchAdvanced.vue")
  }
})
export default class MultiSelectBt extends Vue {
  @Prop(Array) optSearch!: any;
  @Prop(Array) options!: any;
  @Prop(String) text_btn!: string;
  @Prop(Boolean) withAdvanced!: boolean;
  @Prop(Boolean) showLabels!: boolean;
  @Prop(Function) onClick!: any;
  optionsPlaces = [];
  areaOptions = [];
  advancedSearch = false;
  areaValue = "";
  locationValue = "";
  msjSlot = "Escribe una ubicacion";

  async mounted() {
    (this as any).areaOptions = (
      await (this as any).$root._get("area", {})
    ).data.map((item: any) => {
      return { ...item, label: item.description };
    });
  }

  async fetchOptions(search: any, loading: any) {
    if (search.length > 2) {
      loading(true);
      const response = await (this as any).$root._get(
        `misc/locations?q=${search}&addp=1`,
        {}
      );
      (this as any).optionsPlaces = response;
      loading(false);
      if (response.length === 0) {
        (this as any).msjSlot = "Lo sentimos, no hay resultados.";
      }
    } else {
      this.msjSlot = "Escribe una ubicacion";
    }
  }

  closeSearch() {
    this.advancedSearch = false;
  }

  advancedSearchF() {
    this.advancedSearch = true;
  }

  selectEvent(event: any, type: string) {
    if (!(this as any).showLabels) {
      (this as any).doSearch(type);
    }
    if (event) {
      (this as any).$root.addTooltip(event);
    }
  }

  doSearch(type: string) {
    if (type === "area") {
      (window as any).location = `/ofertas/${(this as any).areaValue.id}/-`;
    } else {
      (window as any).location = `/ofertas/-/${(this as any).locationValue.id}`;
    }
  }
}
